import AppHeader from "@/components/AppHeader";

export default {
  name: "master-position-edit",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.getPosition();
  },
  data() {
    return {
      position: {
        company_id: "",
        name: "",
        priority: "",
        default_authority: ""
      },
      companies: "",
      getCompaniesEnd: false,
      getPositionEnd: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async getPosition() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_POSITION", {
          id: this.$route.params.position_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.position.company_id = res.position.company_id;
      this.position.name = res.position.name;
      this.position.priority = res.position.priority;
      this.position.default_authority = res.position.default_authority;
      this.getPositionEnd = true;
    },
    async editPosition() {
      let data = this.position;
      let res = await this.$store
        .dispatch("EDIT_POSITION", {
          id: this.$route.params.position_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_position" });
      }
    },
    goMasterPosition() {
      this.$router.push({ path: "/master_position" });
    }
  }
};
